import { render, staticRenderFns } from "./Technical.vue?vue&type=template&id=a59ab99e&scoped=true&"
import script from "./Technical.vue?vue&type=script&lang=js&"
export * from "./Technical.vue?vue&type=script&lang=js&"
import style0 from "./Technical.vue?vue&type=style&index=0&id=a59ab99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59ab99e",
  null
  
)

export default component.exports